import axios from 'axios';

import { getBackendBaseUrl } from '@/api/backendAuth';

export interface PaddleClientBootstrap {
  token: string;
  sandbox: boolean;
}

/**
 * When `REACT_APP_PADDLE_DEV_CLIENT_TOKEN` is set, checkout skips POST client-token/bootstrap
 * and uses this token with `initializePaddle` (local Paddle testing only).
 */
export function readPaddleDevClientTokenOverride(): PaddleClientBootstrap | null {
  const token = (process.env.REACT_APP_PADDLE_DEV_CLIENT_TOKEN || '').trim();
  if (!token) return null;
  const explicit = (process.env.REACT_APP_PADDLE_DEV_SANDBOX ?? '').trim();
  // When unset, infer from token prefix so we never pair live_ tokens with sandbox:true (Paddle.js → 403 on checkout).
  const sandbox =
    explicit === ''
      ? !token.startsWith('live_')
      : explicit.toLowerCase() !== 'false' && explicit !== '0';
  return { token, sandbox };
}

export async function fetchPaddleCheckoutBootstrap(): Promise<PaddleClientBootstrap> {
  const o = readPaddleDevClientTokenOverride();
  if (o) return o;
  const base = getBackendBaseUrl();
  const { data } = await axios.post<PaddleClientBootstrap>(`${base}/billing/paddle/checkout-bootstrap`);
  return data;
}
